import { LitElement, html, css } from 'lit';
import { store } from '../../redux/store';
import { positiveFeedback, negativeFeedback } from '../../redux/actions/app_actions';

export class PaeRecoverStudent extends LitElement {
    static styles = [
        css`
            :host {
                display: block;
            }
            dile-confirm p {
                text-align: center;
            }
        `
    ];

    static get properties() {
      return {
        studentId: { type: String }
      };
    }

    render() {
        return html`
        <dile-confirm acceptLabel="Recuperar" cancelLabel="No" @dile-confirm-accepted=${this.recover}>
            <p>¿De verdad deseas<br>recuperar este sigsa?</p>
        </dile-confirm>
        <rounded-button @click=${this.confirm}>Recuperar</rounded-button>
        <dw-ajax
            id="recoverAjax"
            url="/papelera/recover/${this.studentId}"
            method="post"
            @ajax-success="${this.ajaxSuccess}"
            @ajax-error="${this.ajaxError}"
        ></dw-ajax>
        `;
    }

    confirm() {
        this.shadowRoot.querySelector('dile-confirm').open();
    }

    recover() {
        this.shadowRoot.getElementById('recoverAjax').generateRequest();
    }

    ajaxError(e) {
        console.log('error', e.detail);
        store.dispatch(negativeFeedback(e.detail));
      }

    ajaxSuccess(e) {
        window.location = `/alumnos/${this.studentId}/editar`
    }
}
customElements.define('pae-recover-student', PaeRecoverStudent);
